import { Grid } from '@material-ui/core';
import React, { useContext } from 'react';
import ReportGijgoGrid from '../ReportsScreens/GijgoForReportsScreen';
import formatters from '../../../Core/Grid/inputFormatter';
import AppContext from '../../../App/AppContext';

const escapeText = (str) => {
    if (!str) return '';
    return String(str).replace(/\\/g, '\\\\').replace(/'/g, "\\'").replace(/"/g, '&quot;').replace(/\n/g, ' ').replace(/\r/g, '');
};

const baseColumns = [
    { field: 'lne', sortable: false, title: `LINE`, filterable: false, width: 30 },
    { field: 'opc', sortable: true, title: `OPC`, filterable: false, width: 60 },
    {
        field: 'description',
        sortable: true,
        title: `DESCRIPTION`,
        filterable: false,
        width: 240,
        renderer: (val, record) => {
            if (!val) return '';
            const safeText = escapeText(val);
            const copyIconHtml = `<span onclick="window.copyLabourDescription('${safeText}', event)" title="Copy description to clipboard" style="cursor:pointer;margin-right:6px;display:inline-flex;align-items:center;color:#1976d2;flex-shrink:0;" onmouseover="this.style.color='#0d47a1'" onmouseout="this.style.color='#1976d2'"><svg style="width:15px;height:15px;" viewBox="0 0 24 24"><path fill="currentColor" d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"/></svg></span>`;
            return `<div style="display:flex;align-items:center;">${copyIconHtml}<span>${val}</span></div>`;
        }
    },
    { field: 'qty', sortable: true, title: `QTY`, align: 'right', filterable: false, width: 30 },
    { field: 'usp', sortable: true, title: `USP`, align: 'right', filterable: false, width: 40 },
    {
        field: 'timeSpent',
        sortable: true,
        title: 'TIME SPENT',
        align: 'right',
        filterable: false,
        width: 40,
        renderer: (val, record) => {
            return record.timeSpent !== undefined ? formatters.ToFixedSeparator(+record.timeSpent) : '';
        }
    },
    {
        field: 'amountInv',
        sortable: true,
        title: 'TIME INVOICED',
        align: 'right',
        filterable: false,
        width: 40,
        renderer: (val, record) => {
            return record.amountInv !== undefined ? record.amountInv : '';
        }
    },
    {
        field: 'amount',
        title: 'AMOUNT',
        align: 'right',
        filterable: false,
        sortable: false,
        width: 40,
        renderer: (val, record) => {
            return record.amount !== undefined ? formatters.CurrencyThousandSeparator(+record.amount) : '';
        }
    }
];
const Labour = (props) => {
    const { showToast } = useContext(AppContext);

    window.copyLabourDescription = (text, event) => {
        if (event) event.stopPropagation();
        if (!text) return;

        const fallbackCopy = (txt) => {
            const textArea = document.createElement('textarea');
            textArea.value = txt;
            document.body.appendChild(textArea);
            textArea.select();
            document.execCommand('copy');
            document.body.removeChild(textArea);
            showToast && showToast('Description copied to clipboard');
        };

        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard
                .writeText(text)
                .then(() => {
                    showToast && showToast('Description copied to clipboard');
                })
                .catch(() => {
                    fallbackCopy(text);
                });
        } else {
            fallbackCopy(text);
        }
    };

    console.log(props, 'ooo');
    return (
        <Grid item container spacing={1} xs={12}>
            <Grid item xs={12}>
                <ReportGijgoGrid localRowsData={props.List} columns={baseColumns} hidePagination={true} hideFilterRow={true} />
            </Grid>
        </Grid>
    );
};

export default Labour;
